import SaveProductoServicio from "../../shared/componente/save_producto_servicio/SaveProductoServicio";

export default function CreateProductoServicioPage() {


  return (
    <SaveProductoServicio
      title="Crear Servicio"
    />
  )

}